import React from 'react'
import cloudTwo from '../../images/medium-clouds.svg'
import styles from "./animation.module.css"


export default class CloudTwo extends React.Component {

  render(){
    return (
             
                <div className={styles[`animateCloudTwo`]}
                	 css={{position:`absolute`,
                	 		 top:`-5%`,
                	 		 bottom:`0`,
                	 		 left:`-25%`,
                	 		 width:`100%`,
                	 		 height:`100%`,
                	 		 opacity:`.60`,
                	 		 '@media(min-width:800px)':{
                	 		 	top:'10%',
                                left:'5%'
                	 		 }
                	 		}}>

                    <img css={{transform:`scale(1.5)`,
                    		   '@media(min-width:800px)':{
                    		   	transform:'scale(1)'
                    		   }

                    			}} 

                    src={cloudTwo} alt="cloud two" />
                </div>
            
      )
  }
}
